import deTranslations from "./de.json";
import enTranslations from "./en.json";

export const de = deTranslations;
export const en = enTranslations;
